var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnDownloadLogsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.795,
    height: 13.278,
    viewBox: "0 0 17.795 13.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-download-15",
    d: "M14.443,8.232a5.555,5.555,0,0,0-11.091,0,4.054,4.054,0,0,0,.726,8.047h9.639a4.054,4.054,0,0,0,.726-8.047ZM8.9,13.328,5.932,10.377H8.156V7.426H9.639v2.951h2.224Z",
    transform: "translate(0 -3)",
    fill: "#a9a9a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnDownloadLogsIcon);
export default __webpack_public_path__ + "static/media/un-download-logs-icon.748ca813bddeba455e3f61a5c51d2f2b.svg";
export { ForwardRef as ReactComponent };